<div class="cmd-palette" role="combobox" aria-haspopup="listbox" aria-expanded="true" [attr.aria-controls]="'cmd-palette-listbox'">

	<!-- Input -->
	<header class="cmd-palette__head">
		<mat-icon class="cmd-palette__head-icon" aria-hidden="true">search</mat-icon>
		<input #input type="text" class="cmd-palette__input" [formControl]="query"
			[placeholder]="'commandPalette.placeholder' | translate"
			[attr.aria-label]="'commandPalette.placeholder' | translate"
			autocomplete="off" spellcheck="false" autocapitalize="off" role="searchbox" />
		<button type="button" class="cmd-palette__esc" (click)="dialogRef.close()" [attr.aria-label]="'commandPalette.close' | translate">
			<kbd>Esc</kbd>
		</button>
	</header>

	<span class="cmd-palette__sr" role="status" aria-live="polite">{{ countMessage }}</span>

	<!-- Cuerpo -->
	<div class="cmd-palette__body" #list>

		<!-- Skeleton de carga -->
		<ng-container *ngIf="!ready">
			<div class="cmd-skel" *ngFor="let i of [1,2,3,4,5]" aria-hidden="true">
				<span class="cmd-skel__dot"></span>
				<span class="cmd-skel__lines">
					<span class="cmd-skel__line cmd-skel__line--head"></span>
					<span class="cmd-skel__line cmd-skel__line--sub"></span>
				</span>
			</div>
		</ng-container>

		<!-- Estado vacío -->
		<div class="cmd-palette__empty" *ngIf="ready && flat.length === 0" role="status">
			<span class="cmd-palette__empty-glyph" aria-hidden="true"><mat-icon>travel_explore</mat-icon></span>
			<p class="cmd-palette__empty-title">
				{{ (query.value ? 'commandPalette.empty.noResults' : 'commandPalette.empty.start') | translate }}
				<ng-container *ngIf="query.value">"{{ query.value }}"</ng-container>
			</p>
			<p class="cmd-palette__empty-hint">{{ 'commandPalette.empty.hint' | translate }}</p>
		</div>

		<!-- Resultados agrupados -->
		<ul *ngIf="ready && flat.length > 0" id="cmd-palette-listbox" class="cmd-list" role="listbox">
			<ng-container *ngFor="let group of groups">
				<li class="cmd-list__group-header" role="presentation">
					{{ group.label | translate }}
					<span class="cmd-list__group-count">{{ group.entries.length }}</span>
				</li>
				<li *ngFor="let entry of group.entries; trackBy: trackById"
					[id]="'cmd-opt-' + entry.id"
					[attr.data-flat-index]="indexOf(entry)"
					class="cmd-opt" [class.cmd-opt--active]="isActive(entry)"
					role="option" [attr.aria-selected]="isActive(entry)"
					(click)="onClickEntry(entry)" (mouseenter)="onPointerEnter(entry)">
					<span class="cmd-opt__icon" [ngClass]="'cmd-opt__icon--' + entry.tone" aria-hidden="true">
						<mat-icon>{{ entry.icon }}</mat-icon>
					</span>
					<span class="cmd-opt__content">
						<span class="cmd-opt__headline">
							<span class="cmd-opt__title" [innerHTML]="entry.title | highlightSearch: query.value"></span>
							<span class="cmd-opt__badge" [ngClass]="'cmd-opt__badge--' + entry.tone">{{ entry.badge | translate }}</span>
						</span>
						<span class="cmd-opt__subtitle" *ngIf="entry.subtitle" [innerHTML]="entry.subtitle | highlightSearch: query.value"></span>
					</span>
				</li>
			</ng-container>
		</ul>
	</div>

	<!-- Footer -->
	<footer class="cmd-palette__footer">
		<span class="cmd-palette__footer-group">
			<kbd class="cmd-kbd">↑</kbd><kbd class="cmd-kbd">↓</kbd>
			<span>{{ 'commandPalette.footer.navigate' | translate }}</span>
		</span>
		<span class="cmd-palette__footer-group">
			<kbd class="cmd-kbd">↩</kbd>
			<span>{{ 'commandPalette.footer.open' | translate }}</span>
		</span>
		<span class="cmd-palette__footer-group cmd-palette__footer-group--end">
			<kbd class="cmd-kbd">Esc</kbd>
			<span>{{ 'commandPalette.footer.close' | translate }}</span>
		</span>
	</footer>
</div>
